import React, { useState, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import HttpService from '../../services/httpService'
import { Table, Button, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, IconButton, InputAdornment, CircularProgress, Chip, TableSortLabel, TablePagination, Grid, LinearProgress } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Tooltip from '@material-ui/core/Tooltip';
// Material-UI icons throughout - the Ant Design set these replace was the odd
// one out against every other page in the app, and read as dated beside them.
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import LocationCityOutlinedIcon from '@material-ui/icons/LocationCityOutlined';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import PublicOutlinedIcon from '@material-ui/icons/PublicOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

const ORANGE = "#F47E44";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#fff1ea";
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const RED = "#c0392b";
const RED_LIGHT = "#fdecea";
const HEADING_FONT = "'Silka bold', 'Silka semiBold', sans-serif !important";

// Warm, on-brand palette for the per-location avatar chips - cycled by index
const AVATAR_COLORS = [
  { bg: "#fff1ea", fg: "#c1531f" },
  { bg: "#fff4d6", fg: "#b8860b" },
  { bg: "#e8f6ef", fg: "#1e8a5f" },
  { bg: "#eaf1ff", fg: "#2c5fb8" },
  { bg: "#f5ecff", fg: "#7b3fd6" },
  { bg: "#ffeaf1", fg: "#c1315f" },
];

const getAvatarColor = (name = "") => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Indeterminate bar shown while the list is being fetched. Same treatment as
// the Experience Centers page and the Move to Marketing classifier dashboard,
// which share this orange palette, so they read as one system.
const BrandLinearProgress = withStyles(() => ({
  root: {
    height: 4,
    borderRadius: 999,
    backgroundColor: "rgba(193,83,31,0.10)",
  },
  bar: {
    borderRadius: 999,
    background: `linear-gradient(90deg, ${ORANGE_DARK}, ${ORANGE}, #ff9c66)`,
  },
}))(LinearProgress);

const useStyles = makeStyles({
  page: {
    padding: "4px 2px 24px",
  },
  headerCard: {
    position: "relative",
    background: HEADER_GRADIENT,
    borderRadius: 18,
    padding: "24px 28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 16,
    marginBottom: 20,
    boxShadow: "0 10px 28px rgba(244, 126, 68, 0.3)",
    overflow: "hidden",
  },
  headerGlowOne: {
    position: "absolute",
    top: -60,
    right: -40,
    width: 180,
    height: 180,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.12)",
    pointerEvents: "none",
  },
  headerGlowTwo: {
    position: "absolute",
    bottom: -70,
    right: 120,
    width: 140,
    height: 140,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.08)",
    pointerEvents: "none",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
    position: "relative",
    zIndex: 1,
  },
  iconBadge: {
    width: 56,
    height: 56,
    borderRadius: 16,
    background: "rgba(255,255,255,0.22)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 28,
    color: "#fff",
    flexShrink: 0,
    boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.25)",
  },
  headerTitle: {
    color: "#fff",
    fontFamily: HEADING_FONT,
    fontSize: 23,
    margin: 0,
  },
  headerSubtitle: {
    color: "rgba(255,255,255,0.88)",
    fontSize: 13,
    margin: "4px 0 0",
  },
  statChip: {
    background: "rgba(255,255,255,0.22)",
    color: "#fff",
    fontWeight: 600,
    fontSize: 13,
    height: 30,
  },
  // Deliberately NOT the usual red: on this orange banner a red chip is both
  // low-contrast and easy to read as decoration. A solid dark fill with white
  // text separates it from the translucent stat chips beside it.
  warnChip: {
    background: "rgba(0,0,0,0.32)",
    color: "#fff",
    fontWeight: 700,
    fontSize: 13,
    height: 30,
    border: "1px solid rgba(255,255,255,0.45)",
    cursor: "help",
  },
  headerActions: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  // Solid white with a ring rather than a translucent fill: white-on-gradient
  // at low opacity measures around 2:1 against the lighter end of this banner.
  refreshBtn: {
    background: "#fff",
    color: ORANGE_DARK,
    fontWeight: 700,
    borderRadius: 10,
    textTransform: "none",
    padding: "9px 18px",
    border: `1px solid ${ORANGE_DARK}`,
    boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
    "&:hover": { background: "#fff1ea" },
    "&.Mui-disabled": { background: "rgba(255,255,255,0.75)", color: ORANGE_DARK },
  },
  spin: {
    animation: "$spin 0.9s linear infinite",
  },
  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
  lastUpdatedText: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 6,
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(255,255,255,0.92)",
  },
  liveDot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    background: "#8ef5b5",
    boxShadow: "0 0 0 3px rgba(142,245,181,0.25)",
  },
  addBtn: {
    background: "#fff",
    color: ORANGE_DARK,
    fontWeight: 700,
    borderRadius: 10,
    textTransform: "none",
    padding: "9px 22px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
    position: "relative",
    zIndex: 1,
    transition: "transform .15s ease",
    "&:hover": {
      background: "#fff1ea",
      transform: "translateY(-1px)",
    },
  },
  filterCard: {
    background: "#fff",
    borderRadius: 16,
    padding: "16px 20px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    display: "flex",
    alignItems: "center",
    gap: 14,
    flexWrap: "wrap",
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: "#8a8a8a",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginRight: 4,
  },
  searchField: {
    width: 300,
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      "&.Mui-focused fieldset": {
        borderColor: ORANGE,
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: ORANGE_DARK,
    },
  },
  clearBtn: {
    color: ORANGE_DARK,
    textTransform: "none",
    fontWeight: 600,
  },
  stateFilter: {
    width: 200,
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      "&.Mui-focused fieldset": { borderColor: ORANGE },
    },
  },
  // Always occupies the bar's height, whether or not the bar is showing.
  progressSlot: {
    height: 4,
    marginBottom: 10,
  },
  loadingBanner: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "9px 14px",
    marginBottom: 14,
    borderRadius: 12,
    background: ORANGE_LIGHT,
    border: `1px solid ${ORANGE}33`,
  },
  loadingBannerTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: ORANGE_DARK,
  },
  loadingBannerHint: {
    fontSize: 11.5,
    color: "#7a6a60",
    marginTop: 1,
  },
  resultCount: {
    marginLeft: "auto",
    fontSize: 13,
    color: "#999",
  },
  tableCard: {
    borderRadius: 18,
    overflow: "hidden",
    boxShadow: "0 2px 14px rgba(0,0,0,0.07)",
  },
  tableScrollWrap: {
    maxHeight: "calc(100vh - 420px)",
    minHeight: 200,
    overflowY: "auto",
  },
  table: {
    minWidth: 700,
  },
  tableHeadCell: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: ORANGE_DARK,
    color: "#fff",
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: 0.3,
    border: "none",
  },
  sortLabel: {
    color: "#fff !important",
    "&:hover": {
      color: "#fff !important",
    },
    "& .MuiTableSortLabel-icon": {
      color: "#fff !important",
    },
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fbfbfb",
    },
    "&:hover": {
      backgroundColor: ORANGE_LIGHT,
    },
    transition: "background-color .15s ease",
  },
  tableCell: {
    fontSize: 14,
    color: "#333",
  },
  nameCell: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  avatarChip: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 14,
    flexShrink: 0,
  },
  stateChip: {
    height: 24,
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: "#eef2f7",
    color: "#546073",
  },
  dateText: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    color: "#888",
  },
  actionCell: {
    display: "flex",
    gap: 8,
  },
  editBtn: {
    color: ORANGE_DARK,
    backgroundColor: ORANGE_LIGHT,
    transition: "transform .15s ease, background-color .15s ease",
    "&:hover": { backgroundColor: "#ffe3d2", transform: "scale(1.08)" },
  },
  deleteBtn: {
    color: RED,
    backgroundColor: RED_LIGHT,
    transition: "transform .15s ease, background-color .15s ease",
    "&:hover": { backgroundColor: "#fadbd8", transform: "scale(1.08)" },
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "64px 20px",
    color: "#9b9b9b",
    background: "#fff",
  },
  emptyIcon: {
    fontSize: 46,
    color: "#e0b8a4",
    marginBottom: 12,
  },
  emptyTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: "#666",
  },
  emptyHint: {
    fontSize: 13,
    color: "#aaa",
    marginTop: 4,
  },
  pagination: {
    borderTop: "1px solid #f0f0f0",
  },
  dialogHeader: {
    background: HEADER_GRADIENT,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "18px 24px",
  },
  dialogHeaderDelete: {
    background: `linear-gradient(135deg, #922b21, ${RED})`,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "18px 24px",
  },
  dialogTitleWrap: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  dialogIconBadge: {
    width: 34,
    height: 34,
    borderRadius: 10,
    background: "rgba(255,255,255,0.22)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 17,
  },
  dialogTitleText: {
    fontFamily: HEADING_FONT,
    fontSize: 18,
  },
  dialogCloseBtn: {
    color: "#fff",
  },
  dialogContent: {
    padding: "26px 24px 10px",
  },
  inputField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      "&.Mui-focused fieldset": {
        borderColor: ORANGE,
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: ORANGE_DARK,
    },
  },
  submitBtn: {
    background: HEADER_GRADIENT,
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 10,
    padding: "8px 22px",
    "&:hover": {
      background: HEADER_GRADIENT,
      opacity: 0.92,
    },
  },
  cancelBtn: {
    color: "#666",
    textTransform: "none",
    fontWeight: 600,
  },
  deleteConfirmBtn: {
    background: `linear-gradient(135deg, #922b21, ${RED})`,
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 10,
    padding: "8px 22px",
    "&:hover": {
      background: `linear-gradient(135deg, #922b21, ${RED})`,
      opacity: 0.92,
    },
  },
  warningIconWrap: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    background: RED_LIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 14px",
  },
  warningIcon: {
    fontSize: 30,
    color: RED,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    border: "none",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const Location = (props) => {
  const classes = useStyles();

  const [locationModal, setLocationModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [locationList, setLocationList] = useState([])
  const [locationData, setLocationData] = useState({
    _id: "",
    name: "",
    state: ""
  })
  const [dataLoading, setDataLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [deleteTarget, setDeleteTarget] = useState(null)
  const [deleting, setDeleting] = useState(false)
  const [sortOrder, setSortOrder] = useState("asc")
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [nameError, setNameError] = useState("")
  // When the list on screen was last pulled. Only set on a SUCCESSFUL fetch, so
  // a failed refresh never makes stale rows look fresh.
  const [lastUpdated, setLastUpdated] = useState(null)
  // "Updated 4 minutes ago" is only true at the instant it renders, so a slow
  // tick re-renders it. 30s is plenty - moment rounds to the minute anyway.
  const [nowTick, setNowTick] = useState(Date.now())
  const [stateFilter, setStateFilter] = useState(null)

  useEffect(() => {
    const id = setInterval(() => setNowTick(Date.now()), 30000)
    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    getLocation()
    // eslint-disable-next-line
  }, [])

  // Checks the already-loaded list (fetched from the DB) for another location
  // with the same name, case-insensitively. `excludeId` skips the record being edited.
  const findDuplicateLocation = (name, excludeId) => {
    const normalizedName = name?.trim().toLowerCase()
    if (!normalizedName) return null
    return locationList.find((loc) =>
      loc?._id !== excludeId && loc?.name?.trim().toLowerCase() === normalizedName
    ) || null
  }

  const submit = async () => {
    if (!locationData.name?.trim()) {
      props.setSnackInfo('Please enter a location name', 'error')
      return
    }
    const duplicate = findDuplicateLocation(locationData.name)
    if (duplicate) {
      setNameError(`"${duplicate.name}" already exists. Please use a different name.`)
      return
    }
    setSubmitting(true)
    try {
      await HttpService.addLocation({ name: locationData.name, state: locationData.state })
      setLocationModal(false)
      props.setSnackInfo('Location Added', 'success')
      setLocationData({ _id: "", name: "", state: "" })
      getLocation()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    setSubmitting(false)
  }

  const update = async () => {
    if (!locationData.name?.trim()) {
      props.setSnackInfo('Please enter a location name', 'error')
      return
    }
    const duplicate = findDuplicateLocation(locationData.name, locationData._id)
    if (duplicate) {
      setNameError(`"${duplicate.name}" already exists. Please use a different name.`)
      return
    }
    setSubmitting(true)
    try {
      await HttpService.updateLocation(locationData._id, { name: locationData.name, state: locationData.state })
      setLocationModal(false)
      props.setSnackInfo('Location Updated', 'success')
      setIsEdit(false)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    setSubmitting(false)
    getLocation()
  }

  const getLocation = async () => {
    setDataLoading(true)
    try {
      const response = await HttpService.getLocation()
      setLocationList(response.data)
      // Inside the try, after the assignment: a fetch that threw leaves the
      // previous timestamp alone rather than vouching for stale data.
      setLastUpdated(moment())
    } catch (error) {
      console.error(error)
      setLocationList([])
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    setDataLoading(false)
  }

  const editLocation = (data) => {
    setLocationData({ name: data.name, _id: data._id, state: data.state || "" })
    setNameError("")
    setLocationModal(true)
    setIsEdit(true)
  }

  const closeModal = () => {
    setLocationModal(false)
    setIsEdit(false)
    setLocationData({ _id: "", name: "", state: "" })
    setNameError("")
  }

  const confirmDeleteLocation = async () => {
    if (!deleteTarget) return
    setDeleting(true)
    try {
      await HttpService.deleteLocation(deleteTarget._id)
      props.setSnackInfo('Location Deleted', "success")
      setDeleteTarget(null)
      getLocation()
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    setDeleting(false)
  }

  const toggleSort = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
  }

  const filteredList = useMemo(() => {
    let list = [...locationList]
    if (stateFilter) {
      list = list.filter((data) => data?.state === stateFilter)
    }
    if (searchText.trim()) {
      const q = searchText.trim().toLowerCase()
      list = list.filter((data) => data?.name?.toLowerCase().includes(q) || data?.state?.toLowerCase().includes(q))
    }
    list.sort((a, b) => {
      const cmp = (a?.name || "").localeCompare(b?.name || "")
      return sortOrder === "asc" ? cmp : -cmp
    })
    return list
  }, [locationList, searchText, sortOrder, stateFilter])

  const paginatedList = useMemo(() => {
    const start = page * rowsPerPage
    return filteredList.slice(start, start + rowsPerPage)
  }, [filteredList, page, rowsPerPage])

  useEffect(() => {
    setPage(0)
  }, [searchText, stateFilter])

  const stateCount = useMemo(() => {
    return new Set(locationList.filter((l) => l?.state?.trim()).map((l) => l.state.trim().toLowerCase())).size
  }, [locationList])

  // Only the states that actually have a location - offering anything else
  // would let someone pick a value that filters the table to nothing.
  const stateOptions = useMemo(() => {
    return [...new Set(locationList.map((l) => l?.state).filter((s) => s && s.trim()))]
      .sort((a, b) => a.localeCompare(b))
  }, [locationList])

  // A location with no state set. Not fatal, but it is what makes the State
  // column and this filter incomplete, so it is worth naming rather than
  // leaving as a column of dashes nobody explains.
  const missingStateCount = useMemo(
    () => locationList.filter((l) => !l?.state || !l.state.trim()).length,
    [locationList]
  )

  return (
    <div className={classes.page}>
      <div className={classes.headerCard}>
        <div className={classes.headerGlowOne} />
        <div className={classes.headerGlowTwo} />
        <div className={classes.headerLeft}>
          <div className={classes.iconBadge}>
            <LocationOnOutlinedIcon />
          </div>
          <div>
            <h2 className={classes.headerTitle}>Locations</h2>
            <p className={classes.headerSubtitle}>Manage the list of locations used across the ERP</p>
          </div>
          <Chip className={classes.statChip} icon={<LocationCityOutlinedIcon style={{ color: "#fff" }} />} label={`${locationList.length} Location${locationList.length === 1 ? "" : "s"}`} />
          {stateCount > 0 && (
            <Chip className={classes.statChip} icon={<PublicOutlinedIcon style={{ color: "#fff" }} />} label={`${stateCount} State${stateCount === 1 ? "" : "s"}`} />
          )}
          {/* Only when there is something to report - a permanent "0 without a
              state" chip would become background noise. */}
          {missingStateCount > 0 && (
            <Tooltip title="These locations have no state set, so they are missing from the State column and cannot be found by the state filter. Edit each to add one.">
              <Chip
                className={classes.warnChip}
                icon={<ReportProblemOutlinedIcon style={{ color: "#fff" }} />}
                label={`${missingStateCount} without a state`}
              />
            </Tooltip>
          )}
        </div>
        <div className={classes.headerActions}>
          <Tooltip
            title={
              lastUpdated
                ? `Last loaded at ${lastUpdated.format("DD MMM YYYY, hh:mm:ss A")} — click to reload`
                : "Reload the locations"
            }
          >
            {/* A disabled button fires no mouse events, so the tooltip would
                die exactly when it is most wanted - mid-refresh. */}
            <span style={{ display: "inline-flex" }}>
              <Button
                className={classes.refreshBtn}
                onClick={getLocation}
                disabled={dataLoading}
                startIcon={<RefreshIcon className={dataLoading ? classes.spin : ""} />}
              >
                {dataLoading ? "Refreshing…" : "Refresh"}
              </Button>
            </span>
          </Tooltip>
          <Button
            className={classes.addBtn}
            startIcon={<AddIcon />}
            onClick={() => setLocationModal(true)}
          >
            Add Location
          </Button>
          {lastUpdated && (
            <div className={classes.lastUpdatedText}>
              <span className={classes.liveDot} />
              {dataLoading ? "Loading…" : `Updated ${moment(lastUpdated).from(nowTick)}`}
            </div>
          )}
        </div>
      </div>

      <div className={classes.filterCard}>
        <span className={classes.sectionLabel}>Search</span>
        <TextField
          className={classes.searchField}
          size="small"
          variant="outlined"
          placeholder="Search by name or state"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "#aaa" }} />
              </InputAdornment>
            ),
          }}
        />
        {/* Only the states that actually have a location, so every option
            returns rows. */}
        {stateOptions.length > 1 && (
          <Autocomplete
            size="small"
            options={stateOptions}
            value={stateFilter}
            onChange={(e, v) => setStateFilter(v)}
            className={classes.stateFilter}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="All states" />
            )}
          />
        )}
        {(searchText || stateFilter) && (
          <Button
            className={classes.clearBtn}
            size="small"
            startIcon={<ClearAllIcon />}
            onClick={() => { setSearchText(""); setStateFilter(null) }}
          >
            Clear
          </Button>
        )}
        <span className={classes.resultCount}>
          {filteredList.length} of {locationList.length} shown
        </span>
      </div>

      {/* Reserved slot rather than a conditional element, so starting a fetch
          does not jog the table down by 4px and back again. */}
      <div className={classes.progressSlot}>
        {dataLoading ? <BrandLinearProgress /> : null}
      </div>

      {/* The bar alone says "something is happening"; this says WHAT, which
          matters most on a refresh - the rows stay on screen then, so without
          it there is nothing to explain why they have not changed yet. */}
      {dataLoading && (
        <div className={classes.loadingBanner}>
          <CircularProgress size={17} thickness={5} style={{ color: ORANGE_DARK }} />
          <div style={{ minWidth: 0 }}>
            <div className={classes.loadingBannerTitle}>Fetching locations…</div>
            <div className={classes.loadingBannerHint}>
              {locationList.length
                ? "Reloading the list — the locations below stay visible until the new data lands."
                : "Pulling every location used across the ERP."}
            </div>
          </div>
        </div>
      )}

      <Paper className={classes.tableCard}>
        {dataLoading && locationList.length === 0 ? (
          // Placeholder rows shaped like real ones, so the card keeps its height
          // and column rhythm instead of collapsing to a spinner and snapping
          // back when the data lands. A REFRESH (list already populated) keeps
          // the existing rows on screen rather than blanking them.
          <TableContainer className={classes.tableScrollWrap}>
            <Table className={classes.table} size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {["Sl No", "Location", "State", "Added On", "Action"].map((h) => (
                    <StyledTableCell key={h} className={classes.tableHeadCell}>{h}</StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 8 }).map((_, i) => (
                  <TableRow key={i}>
                    <StyledTableCell className={classes.tableCell}><Skeleton variant="text" width={20} /></StyledTableCell>
                    <StyledTableCell className={classes.tableCell}>
                      <div className={classes.nameCell}>
                        <Skeleton variant="circle" width={30} height={30} />
                        <Skeleton variant="text" width={150} />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={78} height={22} style={{ borderRadius: 999 }} /></StyledTableCell>
                    <StyledTableCell className={classes.tableCell}><Skeleton variant="text" width={96} /></StyledTableCell>
                    <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={64} height={26} style={{ borderRadius: 8 }} /></StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : filteredList.length === 0 ? (
          <div className={classes.emptyState}>
            <InboxOutlinedIcon className={classes.emptyIcon} />
            <span className={classes.emptyTitle}>{searchText ? "No locations match your search" : "No locations added yet"}</span>
            <span className={classes.emptyHint}>{searchText ? "Try a different name or state" : "Click \"Add Location\" to create the first one"}</span>
          </div>
        ) : (
          <>
            <TableContainer className={classes.tableScrollWrap}>
              <Table className={classes.table} size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.tableHeadCell}>Sl No</StyledTableCell>
                    <StyledTableCell className={classes.tableHeadCell} sortDirection={sortOrder}>
                      <TableSortLabel className={classes.sortLabel} active direction={sortOrder} onClick={toggleSort}>
                        Location
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell className={classes.tableHeadCell}>State</StyledTableCell>
                    <StyledTableCell className={classes.tableHeadCell}>Added On</StyledTableCell>
                    <StyledTableCell className={classes.tableHeadCell}>Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedList?.map((data, i) => {
                    const avatarColor = getAvatarColor(data?.name)
                    return (
                      <TableRow key={data?._id || i} className={classes.tableRow}>
                        <StyledTableCell className={classes.tableCell}>{page * rowsPerPage + i + 1}</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>
                          <div className={classes.nameCell}>
                            <div className={classes.avatarChip} style={{ backgroundColor: avatarColor.bg, color: avatarColor.fg }}>
                              {data?.name?.charAt(0)?.toUpperCase() || "?"}
                            </div>
                            {data?.name}
                          </div>
                        </StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>
                          {data?.state ? <Chip size="small" className={classes.stateChip} label={data.state} /> : <span style={{ color: "#ccc" }}>—</span>}
                        </StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>
                          <div className={classes.dateText}>
                            <EventOutlinedIcon />
                            {data?.createdAt ? moment(data.createdAt).format("DD MMM YYYY") : "—"}
                          </div>
                        </StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>
                          <div className={classes.actionCell}>
                            <Tooltip title="Edit Location">
                              <IconButton size="small" className={classes.editBtn} onClick={() => editLocation(data)}>
                                <EditOutlinedIcon style={{ fontSize: 16 }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Location">
                              <IconButton size="small" className={classes.deleteBtn} onClick={() => setDeleteTarget(data)}>
                                <DeleteOutlineIcon style={{ fontSize: 16 }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              className={classes.pagination}
              component="div"
              count={filteredList.length}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0) }}
              rowsPerPageOptions={[25, 50, 100]}
            />
          </>
        )}
      </Paper>

      <Dialog
        open={locationModal}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth={'sm'}
        onClose={closeModal}
        aria-labelledby="alert-dialog-slide-title"
      >
        <div className={classes.dialogHeader}>
          <div className={classes.dialogTitleWrap}>
            <div className={classes.dialogIconBadge}>
              <LocationOnOutlinedIcon />
            </div>
            <span className={classes.dialogTitleText}>{isEdit ? "Edit Location" : "Add Location"}</span>
          </div>
          <IconButton size="small" className={classes.dialogCloseBtn} onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent className={classes.dialogContent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                className={classes.inputField}
                label="Location Name"
                name="name"
                variant="outlined"
                autoFocus
                error={!!nameError}
                helperText={nameError}
                onChange={(e) => {
                  setLocationData({ ...locationData, name: e.target.value })
                  if (nameError) setNameError("")
                }}
                value={locationData.name}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationOnOutlinedIcon style={{ color: nameError ? RED : "#aaa" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                className={classes.inputField}
                label="State (optional)"
                name="state"
                variant="outlined"
                onChange={(e) => setLocationData({ ...locationData, state: e.target.value })}
                value={locationData.state}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PublicOutlinedIcon style={{ color: "#aaa" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px 22px" }}>
          <Button className={classes.cancelBtn} onClick={closeModal}>
            Cancel
          </Button>
          <Button
            className={classes.submitBtn}
            onClick={isEdit ? update : submit}
            disabled={submitting}
            startIcon={submitting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}
          >
            {isEdit ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!deleteTarget}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="xs"
        onClose={() => setDeleteTarget(null)}
      >
        <div className={classes.dialogHeaderDelete}>
          <span className={classes.dialogTitleText}>Delete Location</span>
          <IconButton size="small" className={classes.dialogCloseBtn} onClick={() => setDeleteTarget(null)}>
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent className={classes.dialogContent} style={{ textAlign: "center" }}>
          <div className={classes.warningIconWrap}>
            <ReportProblemOutlinedIcon className={classes.warningIcon} />
          </div>
          <p style={{ fontSize: 15, color: "#333", margin: 0 }}>
            Are you sure you want to delete <strong>{deleteTarget?.name}</strong>?
          </p>
          <p style={{ fontSize: 13, color: "#999", marginTop: 6 }}>This action cannot be undone.</p>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px 22px", justifyContent: "center" }}>
          <Button className={classes.cancelBtn} onClick={() => setDeleteTarget(null)}>
            Cancel
          </Button>
          <Button
            className={classes.deleteConfirmBtn}
            onClick={confirmDeleteLocation}
            disabled={deleting}
            startIcon={deleting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default connect(null, { setLoading, setSnackInfo })(Location)
